export default __webpack_public_path__ + "static/media/Dwell.b42101ab.svg";